import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IoniconsOutline, TemplateGroup } from '@pt/pt-models';

@Component({
  selector: 'pt-tab-with-scroll',
  templateUrl: './tab-with-scroll.component.html',
  styleUrls: ['./tab-with-scroll.component.scss']
})
export class TabWithScrollComponent implements OnChanges {

  // Potevo farlo generico ma data l'interazione tra i vari componenti ho preferito mantenere comune a tutti i dto in Input Output
  @Input() groups: TemplateGroup[];
  @Input() selectedGroup: TemplateGroup;
  @Input() activeSmallView: boolean;
  @Input() activedEditWidgetId: number;

  @Output() changeGroup = new EventEmitter<TemplateGroup>();
  @ViewChild('tabContent') tabContent;

  STEP = 600;

  IconArrowLeft = IoniconsOutline.chevronBack;
  IconArrowRight = IoniconsOutline.chevronForward;

  showTabArrow = false;
  disabledChangeGroup: boolean;

  changeTab(tab: TemplateGroup) {
    if (!this.disabledChangeGroup) {
      this.selectedGroup = tab;
      this.changeGroup.emit(this.selectedGroup);
    }
  }

  scroolTab(tabContent, value: number) {
    tabContent.scrollLeft = tabContent.scrollLeft + value;
  }


  setShowTabArrow() {
    setTimeout(() => {
      if (this.tabContent) {
        this.showTabArrow = this.tabContent.nativeElement?.scrollWidth > this.tabContent.nativeElement?.offsetWidth;
      } else {
        this.showTabArrow = true;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedTab) {
      if (this.groups?.length > 0) {
        this.selectedGroup = this.selectedGroup ? this.selectedGroup : this.groups[0];
      }
    }

    if (changes.tabs) {
      if (this.groups?.length > 0) {
        this.selectedGroup = this.selectedGroup ? this.selectedGroup : this.groups[0];
      }
    }

    if (changes.activeSmallView) {
      this.setShowTabArrow();
    }

    if (changes.status) {
      this.disabledChangeGroup = Number.isSafeInteger(this.activedEditWidgetId); //this.activedEditWidgetId !== null && this.activedEditWidgetId !== undefined
    }
  }
}
